import gql from 'graphql-tag'

import { LeadFieldsFragment } from 'main/gql/lead'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

export const BOOKMARK_BUTTON_QUERY = gql`
  query BookmarkButton {
    leads: leadsForParent {
      ...LeadFields
    }
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${LeadFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
